import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { acceptPoliciesAction } from '../../redux/slices/userProfile';
import { useDispatch, useSelector } from 'react-redux';

// Placeholder for now
import { TermsText } from './terms';
import { RootState } from '../../redux/store';
import PoliciesSharedView from '../../components/PoliciesSharedView';

const PrivacyPolicy = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const dispatch = useDispatch();

  const accessToken = useSelector((store: RootState) => store.user.tokens.access);

  const navigate = useNavigate();

  const onSubmit = (e: any) => {
    e.preventDefault();

    setLoading(true);
    dispatch(acceptPoliciesAction({ token: accessToken, accepted_privacy_policy: true }));
    navigate('/terms-of-use');
  };

  return (
    <PoliciesSharedView loading={loading} onSubmit={onSubmit} content={TermsText} />
  );
};

export default PrivacyPolicy;
